import {
  styled,
  FormControl,
  Box,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { pxToRem } from '~/theme/typography';

export const dropdown = {
  FormControl: styled(FormControl)(({ theme }) => ({
    // marginRight: '8px',
    width: 'calc((100% - 24px) / 4)',
    maxWidth: '204px',
    [theme.breakpoints.down('desktop')]: {
      maxWidth: 'none',
    },
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
  })),
  Container: styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    gap: '8px',
    [theme.breakpoints.down('tablet')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px 8px',
    },
  })),
  Label: styled(InputLabel)(({ theme }) => ({
    fontSize: pxToRem(16),
    lineHeight: 1,
    color: theme.palette.text.primary,
    '&.MuiInputLabel-shrink': {
      color: '#8D8988',
    },
  })),
  Select: styled(Select)(({ theme }) => ({
    height: '48px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #C3AF00',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #8D8988',
    },
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },
  })),
  Item: styled(MenuItem)(() => ({
    height: '54px',
    '&:hover': {
      backgroundColor: '#FFDED9',
    },
    '&.Mui-selected': {
      backgroundColor: '#FFDED9',
      '&:hover': {
        backgroundColor: '#FFDED9',
      },
    },
  })),
};
